<template>
  <div v-show="show && hasRecord" class="search-history-wrapper">
    <div class="search-history-content">
      <div v-show="item.show" class="history-item" v-for="(item,index) in list" :key="index">
        <div class="history-item-text" @click.stop="clickSearchHistory(item.value)">
          <span>{{item.value}}</span>
        </div>
        <qc-button class="delete-btn" type="icon" @click.stop="deleteSearchHistory(index)">
          <qc-icon type="remove"></qc-icon>
        </qc-button>
      </div>
    </div>
    <div class="mb-5">
      <qc-button type="text" @click="clearSearchHistory">
        {{$t('core.sync_clear_history')}}
      </qc-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchHistory',
  props: {
    // 控制搜索历史记录框展示的属性
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    // 历史记录
    list: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    // 历史记录长度上限
    maxLength: {
      type: Number,
      default: 30,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    // 选择历史记录并点击
    clickSearchHistory(val) {
      this.$emit('click', val);
    },
    // 删除单条历史搜索记录
    deleteSearchHistory(index) {
      this.list.splice(index, 1);
      this.$emit('update');
    },
    // 清空历史搜索记录
    clearSearchHistory() {
      this.list.splice(0);
      this.$emit('update');
    },
  },
  computed: {
    hasRecord() {
      return this.list.some(item => item.show);
    },
  },
  watch: {
    list() {
      if (this.list.length > this.maxLength) {
        this.list.splice(this.maxLength);
        this.$emit('update');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-history-wrapper {
  width: 100%;
  max-height: 240px;
  background-color: #fff;
  position: absolute;
  border: 1px solid #d1d2d3;
  right: 0;
  top: 35px;
  font-size: 12px;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .search-history-content {
    overflow-y: auto;
  }
  .history-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .history-item-text {
      flex: 1;
      padding: 0 10px;
      text-align: start;
      line-height: 30px;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .history-item:hover {
    background-color: #f2f2f2 !important;
  }
  .delete-btn {
  margin: 0 !important;
  }
}
</style>
